import {ruleGenerator} from './rule'
import {findVueMixin} from './findVue'
import moment from 'moment'
import {UUID} from '@/plugins/common'
import CookieOperation from '@/plugins/cookie'
import _ from 'lodash'
import {TableComponent, ColumnComponent} from '../../../../store/form/component'
import { AsyncRequest } from '@/components/form/runtime/components/utils/AjaxRequestLimit.js'
import { isValidaDate } from '@utils'

// import {Crypto} from './cryptoJs'
// const Base64 = require('js-base64').Base64

// 组件方法
const componentMixin = {
  inject: ['dataService', 'eventBus', 'initState', 'redcatApp', 'rcGroupChildren', 'formVm'],
  props: ['parentPath', 'index', 'startSelect', 'isDisableCopy'],
  created () {
    // 分组控件从隐藏转为非隐藏之后,需要重新执行每个子控件的init事件
    if (this.rcGroupChildren && this.rcGroupChildren.hiddenComponent && this.rcGroupChildren.hiddenComponent.length > 0) {
      // 如果控件存在其中且非容器控件的初始化, 则执行普通控件自身的初始化事件
      if (this.component && this.rcGroupChildren.hiddenComponent.find(c => c.id === this.component.id)) {
        !this.isContainerInit && this.init && this.init('rcTableReRender')
      }
    }
    // 初始化控件宽度
    if (this.component && this.component.properties && (this.component.properties.inputWidth || this.component.properties.inputWidth === 0)) {
      this.inputWidth = String(this.component.properties.inputWidth)
    }
  },
  data () {
    return {
      inputWidth: ''
    }
  },
  methods: {
    init (type) {
      /**
       * 事件初始化步骤:
       * 调用父组件(因为数据有父组件持有, 和数据有关的事件都放在父组件注册)
       * 父组件设置监听对象
       * 注册监听事件
       * 改变内容
       */
      if (this.component.properties.related !== undefined && this.component.properties.related.enable) {
        // 调用父控件关联值初始化方法
        if (this.component.archive.enable === false) {
          this.$emit('initRelated', this.component, (data) => {
            this.tempValue = data[this.component.properties.related.srcField]
            if (this.component.properties.related.bindData && this.component.properties.related.bindData.enable && this.component.properties.related.bindData.dataBinding.length > 0) {
              this.component.properties.related.bindData.dataBinding.forEach(d => {
                this.updateChildValue(d.componentId, data[d.showColumnId])
              })
            }
          })
        } else {
          this.$emit('initRelated', this.component)
        }
      }
      if (this.component.properties.default && this.component.properties.default.enable && !this.value) {
        if (this.component.archive.enable === false) {
          this.$emit('initDefaultValue', this.component, (data) => {
            this.tempValue = data
          })
        } else {
          this.$emit('initDefaultValue', this.component)
        }
      } else if (this.component.properties.default && this.component.properties.default.enable && this.component.componentType === 'rc-switch') {
        // rc -switch 支持默认值
        if (this.component.archive.enable === false) {
          this.$emit('initDefaultValue', this.component, (data) => {
            this.tempValue = data
          })
        } else {
          this.$emit('initDefaultValue', this.component)
        }
      }

      if (this.component.properties.calculate && this.component.properties.calculate.enable) {
        this.initCal()
      }
      // fixme: 不归档的控件,当tempValue有值时,赋值临时展示用,暂时只处理了输入类的常用组件
      let tempValueWatch = this.$watch('tempValue', (val) => {
        let inputTypeComponent = ['rc-numeric', 'rc-currency']
        if (!this.component.archive.enable && !this.value && this.value !== 0) {
          if (inputTypeComponent.includes(this.component.componentType)) {
            this.formatValue = val
          }
        }
        tempValueWatch()
      })

      this.eventBus.$emit('component.init', {component: this.component, el: this})
      return this.initComponent && this.initComponent(type)
    },
    getCurrentPath () {
      let path = _.clone(this.parentPath) || []
      if (this.component.archive.enable) {
        if (this.component instanceof TableComponent) {
          path.push(this.component.archive.relationId || this.component.archive.tableId)
        } else {
          path.push(this.component.archive.columnId)
        }
      }
      return path
    },
    getendTimeCurrentPath () {
      let path = _.clone(this.parentPath) || []
      if (this.component.archive.enable) {
        if (this.component instanceof TableComponent) {
          path.push(this.component.archive.relationId || this.component.archive.tableId)
        } else {
          path.push(this.component.properties.archived.endColumnId)
        }
      }
      return path
    },
    getChildrenPath (index) {
      return _.concat(this.getCurrentPath(), index)
    },
    controlClick (component, index) {
      // 禁止复制 这玩意就没用了
      // 判断是否按下ctrl键
      if (this.tableCtrlKey && index !== undefined) {
        this.$emit('controlClick', component, index)
      }
    },
    // 鼠标进入
    controlMouseOver: _.debounce(function (component, index) {
      // 禁止复制 这玩意就没用了
      if (this.isDisableCopy) return false
      // 只有按住 ctrl键移动才需要emit
      if (this.tableCtrlKey && this.startSelect && index !== undefined) {
        this.$emit('controlMove', component, index)
      }
    }),

    /*
    * 执行页面js的方法
    * @param {string} 需要执行的方法类型
    * @param {Number} value 有的控件需要在change时更新归档 , 暂时先放在这里
    * */
    executeFunctions (functionType) {
      if (this.component.properties && this.component.properties.jsActions && this.component.properties.jsActions.length) {
        let functions = this.component.properties.jsActions.filter(f => f.type === functionType)
        let redcatApp = this.redcatApp ? this.redcatApp() : undefined
        functions && functions.length && functions.forEach(async (f) => {
          // 外部接口逻辑
          f.outInterfaceId && this.calcBodyMap(f.bodyMap).then(async disposeBodyMap => {
            await this.getComValue(f.outInterfaceId, disposeBodyMap, f.bindList)
          })
          // 函数逻辑
          redcatApp && redcatApp[f.function] && redcatApp[f.function](this.formVm)
        })
      }
    },
    /**
     * @param interfaceId 接口id
     * @param bodyMap 参数
     * @param bindList 绑定字段
     * */
    async getComValue (interfaceId, bodyMap, bindList) {
      let bindListCope = JSON.parse(JSON.stringify(bindList))
      // 获取接口的数据
      this.$axios.get('/system-api/interface', {params: {id: interfaceId}}).then((res) => {
        let params = res.data
        params.bodyMap = bodyMap
        // get请求要修改url，将新数据拼接
        if (params.method === 'GET') {
          let queryStr = ''
          params.bodyMap.length && params.bodyMap.forEach((item) => {
            queryStr += `&${item.name}=${item.value}`
          })
          params.url = params.url.split('?')[0] + '?' + queryStr.slice(1)
        }
        this.$axios.post('/system-api/interface/run', params).then((res) => {
          let backData = res.data
          bindListCope.forEach((bindData) => {
            if (bindData.key && bindData.bindComId) {
              let val = this.getKeyValue(bindData.key, backData)
              bindData.key = val
            }
          })
          this.updateBindComponents(bindListCope)
        })
      })
    },
    /*
    * 将后端返回数据解析取出相应的值
    * bindData 要取出字段值的结构 如['result','list','title']
    * backData 后端返回数据
    * */
    getKeyValue (bindData, backData) {
      let obj = backData
      let rowIndex = -1
      bindData.forEach((key, index) => {
        // 有可能所选数组行数不对，或者对象没相应字段，造成undefined,直接return
        if (typeof (obj) === 'undefined') {
          return obj
        }
        if (key.indexOf('$&$') === -1) {
          if (rowIndex === -1) {
            obj = obj[key]
          } else {
            obj = obj[rowIndex][key]
            rowIndex = -1
          }
        } else {
          // 当值是含有特殊字符的则代表下面是数组,获取rowindex，用于判断取第几行
          rowIndex = key.replace(/[^0-9]/ig, '') - 1
          // 当‘数组元素’是最后一个字段
          if (index === bindData.length - 1) {
            obj = obj[rowIndex]
          }
        }
      })
      return obj
    },
    /*
    * 更新归档数据
    * bindListCope 要修改的归档组件的列表 如[{key:'',bindComId:''}]
    * */
    updateBindComponents (bindListCope) {
      bindListCope.forEach(bindData => {
        let value = bindData.key
        this.update({'value': value === null || value === undefined || value === '' ? '' : value, 'archiveColumnId': bindData.bindComId})
      })
    },
    inputFocus (component, index) {
      this.executeFunctions('focus')
      this.controlClick(component, index)
    },
    /**
     * 使用计算去执行bodyMap中的计算表达式
     * @param {Object} bodyMap 需要解析的参数
     * @return {Promise} 返回一个promise<T>
     */
    calcBodyMap (bodyMap) {
      return Promise.all(bodyMap.map(m => this.calcParams(m)))
    },
    /**
     * 单独参数走计算
     * @params {Object} 参数
     * @return {Promise} 返回一个执行结果
     */
    calcParams (params) {
      if (!params.calc) return Promise.resolve(params)
      let copyParams = {...params}
      return new Promise(async (resolve, reject) => {
        let valueArr = this.getColumnIds(copyParams.value)
        let variables = {}
        valueArr.forEach(m => {
          variables[m.columnId] = this.dataService.data[m.columnId]
        })
        // 不考虑外链
        await this.$axios.post('/form-api/runtime/calc', {'formula': copyParams.value, variables}, {
          transformResponse: [function (data) {
            // 处理数字长度过长导致精度丢失问题
            return typeof data === 'number' ? data.request.response : data
          }]
        }).then(({data}) => resolve(Object.assign(copyParams, {value: data})))
          // 执行失败的情况下，将值作为空处理
          .catch(e => resolve(Object.assign(copyParams, {value: ''})))
      })
    },
    /**
     * 获取日期/时间区间控件的开始/结束时间
     * @return { Object } 返回一个处理过后得到的计算结果
     * */
    async getStartAndEndDate () {
      let selectData = {
        startData: '',
        endData: ''
      }
      // 兼容历史数据
      if (!this.component.properties.selectData) return selectData
      const startData = this.component.properties.selectData.startData
      const endData = this.component.properties.selectData.endData
      // 设置了开始时间
      if (startData) {
        const result = await this.calcStartAndOrDate(startData)
        selectData.startData = result ? result.data : ''
      }
      if (endData) {
        const result = await this.calcStartAndOrDate(endData)
        selectData.endData = result ? result.data : ''
      }
      return selectData
    },
    /**
     * 执行计算，获取 日期/时间区间控件 设置的开始/结束时间
     * @return { Promise<T> }
     * */
    calcStartAndOrDate (expression) {
      // 拿到所有的归档id
      const valueArr = this.getColumnIds(expression)
      let variables = {}
      valueArr.forEach(m => {
        variables[m.columnId] = this.dataService.data[m.columnId]
      })
      return this.$axios.post('/form-api/runtime/calc', {'formula': expression, variables}, {
        transformResponse: [function (data) {
          // 处理数字长度过长导致精度丢失问题
          return typeof data === 'number' ? data.request.response : data
        }]
      })
    },
    /**
     * 处理开始/结束时间，将开始/结束时间转化为时间戳用于计算
     * @return {Object} 返回处理过后的计算时间戳
     * */
    disposeDate () {
      const format = str => new Date(str).valueOf()
      return {
        startData: isValidaDate(this.selectData.startData) ? format(this.selectData.startData) : Number.NEGATIVE_INFINITY,
        // 未设置结束时间则无限大。
        endData: isValidaDate(this.selectData.endData) ? format(this.selectData.endData) : Number.POSITIVE_INFINITY
      }
    }
  },
  mounted () {
    // 如果开启了禁止复制
    if (this.component.properties.disableCopy) {
      this.$el.addEventListener('copy', e => e.preventDefault())
      // 剪切也不行。
      this.$el.addEventListener('cut', e => e.preventDefault())
    }
    if (this.component.properties.disablePaste) {
      this.$el.addEventListener('paste', e => e.preventDefault())
    }
  },
  computed: {
    getClassByCopy () {
      if (this.isDisableCopy) return 'disable-copy'
      return this.component && this.component.properties && this.component.properties.disableCopy ? 'disable-copy' : ''
    },
    // 日期/时间区间控件配置 (统一配置)
    pickerOptions () {
      // NOTE：61期新增开始时间和结束时间。pickerOptions 这玩意是给定制使用的。所以将定制的 pickerOptions 覆盖 自带的 pickerOptions
      const format = str => new Date(str).valueOf()
      // 将时间转换为 年月日 对比
      const formatDate = str => format(moment(str).format('YYYY-MM-DD'))
      // 开始时间 - 结束时间 需要转化为date，如果是无效时间，就为0
      const {startData, endData} = this.disposeDate()
      const componentPickerOptions = {
        disabledDate: time => {
          return formatDate(time) < formatDate(startData) || formatDate(time) > formatDate(endData)
        }
      }
      const pickerOptions = this.component.properties.pickerOptions
      return pickerOptions ? Object.assign(componentPickerOptions, pickerOptions) : componentPickerOptions
    }
  },
  beforeDestroy () {
    this.$el.removeEventListener('copy', () => {})
    this.$el.removeEventListener('paste', () => {})
  },
  watch: {
    'initState.state': {
      handler (val) {
        if (val) {
          // 触发控件的初始化事件
          this.executeFunctions('load')
        }
      },
      deep: true
    }
  }
}

// 容器init
const containerInitMixin = {
  data () {
    return {
      isContainerInit: true
    }
  },
  inject: {
    currentNodeInteractions: {default: []},
    currentNode: {default: {currentNodeId: ''}}
  },
  created () {
    // 表格的容器标志需要为false，他不是普通容器控件不走这边的init（标志是用来重新渲染的）
    if (this.component && this.component.componentType === 'rc-table') {
      this.isContainerInit = false
    }
    if (this.currentNode.currentNodeId && this.component && this.component.children) {
      let unUpdateContainerType = ['rc-layout']
      if (this.component.componentType && !unUpdateContainerType.includes(this.component.componentType)) {
        this.updateNodeInteractions([this.component.children])
      }
    }
  },
  methods: {
    init () {
      this.eventBus.$emit('component.init', {component: this.component, el: this})
      // 初始化表单控件以及子控件，返回 promise 对象
      // 当表单控件以及子控件初始化完毕，才会继续执行（实际是通过 .then())
      if (this.$refs.children) {
        return Promise.all(this.$refs.children.map(m => m.init()))
      }
    },
    /**
     * NI nodeInteractions
     * @param {Array} components 当前节点要展示的所有组件
     * */
    updateNodeInteractions (components) {
      // 展开成一维数组处理
      this.$_.flattenDeep(components).forEach(component => {
        let currentNIComponents = this.currentNodeInteractions.find(e => e.nodeId === this.currentNode.currentNodeId)
        // 如果当前节点存在节点交互 && 当前节点交互的控件中包含该控件
        if (currentNIComponents && component.id && currentNIComponents.components.includes(component.id)) {
          // 分组控件的节点交互隐藏使用另外的字段处理, 否则会导致子控件不init
          if (component.componentType === 'rc-group') {
            component.properties.NIHidden = true
          } else {
            component.properties.hidden = true
          }
        }
      })
    }
  }
}

// 容器类控件的方法, 譬如表格, 表单
const containerMixin = {
  methods: {
    updateChildValue (columnId, buildData, index) {
      if (buildData && typeof (buildData) === 'object') {
        if (buildData.componentId) {
          let component = this.component.find(m => m.id === buildData.componentId)
          if (component) {
            typeof (index) !== 'undefined' ? this.value[index][component.archive.columnId] = buildData.value : this.value[component.archive.columnId] = buildData.value
          } else {
            // 65期身份证控件 如果在当前组件没找到改控件，便无法更新数据，所以就往父组件找
            this.$emit('input', buildData)
          }
        } else if (buildData.archiveColumnId) {
          typeof (index) !== 'undefined' ? this.value[index][buildData.archiveColumnId] = buildData.value : this.value[buildData.archiveColumnId] = buildData.value
        } else {
          typeof (index) !== 'undefined' ? this.value[index][columnId] = buildData.value : this.value[columnId] = buildData.value
        }
      } else {
        typeof (index) !== 'undefined' ? this.value[index][columnId] = buildData : this.value[columnId] = buildData
      }
      // XXX: 可能需要根据 value 的类型来判断
      //  监听表格数据变化，不想一个个控件监听
      this.eventBus.$emit('table.update', { el: this })
    },
    getChildrenData (component, index) {
      let valueData = typeof (index) !== 'undefined' ? this.value[index] : this.value
      let value
      if (component instanceof TableComponent) {
        if (component.archive.enable) {
          // 如果是归档的容器
          value = valueData[component.archive.relationId]
        } else {
          // 如果是不归档的容器
          value = valueData
        }
      } else if (component instanceof ColumnComponent) {
        if (component.archive.enable) {
          // 如果是时间选择控件需要吧开始时间和结束时间拼接传到控件中
          if (component.componentType === 'rc-time-interval') {
            value = (valueData[component.archive.columnId] || valueData[component.properties.archived.endColumnId]) ? [valueData[component.archive.columnId], valueData[component.properties.archived.endColumnId]] : ''
          } else {
            value = valueData[component.archive.columnId]
          }
        }
      }
      return value
    }
  }
}

// 输入类组件
const inputMixin = {
  mixins: [ruleGenerator],
  inject: ['eventBus'],
  data () {
    return {
      tempValue: '',
      rules: this.buildRule(),
      // 需要走新的 change 事件的控件(输入类的会实时更改归档值的控件)
      inputTypeComponent: ['rc-input', 'rc-numeric', 'rc-id-card', 'rc-currency']
    }
  },
  methods: {
    /**
     * buildData 包含三条数据
     * {
     *  value: "", 修改后的值
     *  componentId: "", 控件的 id
     *  archiveColumnId: "", 归档类的 id
     * }
     * componentId/archiveColumnId 主要用于修改同级控件内容的情况
     *
     */
    update (buildData) {
      this.$emit('input', buildData)
      // [文本框, 数字框, 身份证, 货币框] 走新的 component.change 事件(如果定制要用), 其他控件走原来的 component.update 事件, 实时触发
      if (this.component && this.inputTypeComponent.includes(this.component.componentType)) {
        this.eventBus.$emit('component.change', {component: this.component, value: buildData, el: this})
      } else {
        this.eventBus.$emit('component.update', {component: this.component, value: buildData, el: this})
      }
    },
    customChangeEvent (val) {
      // 文本框 ,数字框 change 的时候做一些处理, 去掉空格 去掉末尾的小数点
      if (this.component && this.component.componentType) {
        switch (this.component.componentType) {
          case 'rc-input':
            this.tempValue = this.tempValue.trim()
            break
          case 'rc-numeric':
            // 处理一下用户输入的数字
            val = this.convertToNumber(val)
            // 失焦的时候重置为归档值
            if (this.component.properties.bit) {
              // 转千分位的展示依然保留
              this.formatValue = this.comdify(this.value.toString())
            } else {
              this.formatValue = this.value
            }
            break
        }
      }
      // [文本框, 数字框, 身份证, 货币框] 数据变动且失焦时才触发 component.update 事件
      this.eventBus.$emit('component.update', {component: this.component, value: val, el: this})
      this.$nextTick(() => this.executeFunctions('blur'))
    },
    // 手动触发控件的校验
    validateFormItem () {
      // 实时校验
      if (!(this.component.properties.limit && this.component.properties.limit.triggerBlur)) {
        this.$refs.elFormItem.validate('change')
      }
      // 超链接组件未归档,失焦时手动触发校验
      if (this.component.componentType === 'rc-hyperlink' && !this.component.archive.enable) {
        this.$refs.elFormItem.validate('blur')
      }
    }
  },
  computed: {
    getProp () {
      let path = this.getCurrentPath()
      return _.tail(path).join('.')
    }
  }
}
// 关联属性
const relFunMixin = {
  methods: {
    callbackRelated (component, object) {
      let callback = object.callback || ((data) => {
        // 关联字段的绑定
        let srcFieldValue = data[component.properties.related.srcField] === undefined ? '' : data[component.properties.related.srcField]
        this.updateChildValue(component.archive.columnId, srcFieldValue, object.index)
        if (component.properties.related.bindData && component.properties.related.bindData.enable && component.properties.related.bindData.dataBinding.length > 0) {
          component.properties.related.bindData.dataBinding.forEach(d => {
            this.updateChildValue(d.componentId, data[d.showColumnId], object.index)
          })
        }
      })
      this.initRelated(callback, component, object.index)
      if (component.componentType === 'rc-time-interval') {
        let callback = object.callback || ((data) => {
          // 关联字段的绑定
          this.updateChildValue(component.properties.archived.endColumnId, data[component.properties.related.secondSrcField], object.index)
          if (component.properties.related.bindData && component.properties.related.bindData.enable && component.properties.related.bindData.secondDataBinding.length > 0) {
            component.properties.related.bindData.secondDataBinding.forEach(d => {
              this.updateChildValue(d.componentId, data[d.showColumnId], object.index)
            })
          }
        })
        this.initSecondRelated(callback, component, object.index)
      }
    },
    // component 需要设置关联的控件, index 索引, 在多行数据下, 可能需要传入这个数据
    initRelated (callback, component, index) {
      let watchObj = typeof (index) !== 'undefined' ? this.value[index] : this.value
      if (component.properties.related.relComponent === 'sessionScope' || component.properties.related.relComponent === 'currentUserId') {
        // 获取登录人信息
        this.$axios.get('/auth-api/oauth/currentUserInfo').then(res => {
          this.setRelValueFun(res.data.id, component, callback, component.properties.related.srcLocation, component.properties.related.srcField, component.properties.related.relField)
        })
      } else {
        // 目标控件的归档字段 id
        let targetComponentId = component.properties.related.relComponent
        let parentComponent = this.parentComponent ? this.parentComponent : this.component
        let targetComponent = parentComponent.archivedChildren.find(n => n.id === targetComponentId)
        if (!targetComponent) {
          throw new Error(`无法找到指定的关联控件`)
        }
        let targetArchivedFieldId = targetComponent.archive.columnId
        // 考虑到在监听之前已经赋值成功，所以在这个地方判断目标有没有值，有值的首先执行一次监听事件
        // XXX: 暂时先注释, 遇见触发的问题了, 在放开注释
        if (watchObj[targetArchivedFieldId]) {
          if (!this.value[component.archive.columnId]) {
            this.setRelValueFun(watchObj[targetArchivedFieldId], component, callback, component.properties.related.srcLocation, component.properties.related.srcField, component.properties.related.relField)
          }
        }
        // 监听目标控件值的变化
        // fixme: 这个地方触发的时候回走四遍, 空闲时注意解决
        this.$watch(() => {
          return watchObj[targetArchivedFieldId]
        }, _.debounce(() => {
          this.setRelValueFun(watchObj[targetArchivedFieldId], component, callback, component.properties.related.srcLocation, component.properties.related.srcField, component.properties.related.relField)
        }, 100))
      }
    },
    initSecondRelated (callback, component, index) {
      let watchObj = typeof (index) !== 'undefined' ? this.value[index] : this.value
      if (component.properties.related.secondRelComponent === 'sessionScope' || component.properties.related.secondRelComponent === 'currentUserId') {
        // 获取登录人信息
        this.$axios.get('/auth-api/oauth/currentUserInfo').then(res => {
          this.setRelValueFun(res.data.id, component, callback, component.properties.related.secondSrcLocation, component.properties.related.secondSrcField, component.properties.related.secondRelField)
        })
      } else {
        // 目标控件的归档字段 id
        let targetComponentId = component.properties.related.secondRelComponent
        let parentComponent = this.parentComponent ? this.parentComponent : this.component
        let targetComponent = parentComponent.archivedChildren.find(n => n.id === targetComponentId)
        if (!targetComponent) {
          throw new Error(`无法找到指定的关联控件`)
        }
        let targetArchivedFieldId = targetComponent.archive.columnId
        // 考虑到在监听之前已经赋值成功，所以在这个地方判断目标有没有值，有值的首先执行一次监听事件
        // XXX: 暂时先注释, 遇见触发的问题了, 在放开注释
        if (watchObj[targetArchivedFieldId]) {
          if (!this.value[component.properties.archived.endColumnId]) {
            this.setRelValueFun(watchObj[targetArchivedFieldId], component, callback, component.properties.related.secondSrcLocation, component.properties.related.secondSrcField, component.properties.related.secondRelField)
          }
        }
        // 监听目标控件值的变化
        // fixme: 这个地方触发的时候回走四遍, 空闲时注意解决
        this.$watch(() => {
          return watchObj[targetArchivedFieldId]
        }, _.debounce(() => {
          this.setRelValueFun(watchObj[targetArchivedFieldId], component, callback, component.properties.related.secondSrcLocation, component.properties.related.secondSrcField, component.properties.related.secondRelField)
        }, 100))
      }
    },
    setRelValueFun (val, component, callback, srcLocation, srcField, relField) {
      this.getRelValue(val, component, srcLocation, srcField, relField).then((res) => {
        // 如果返回的是数字0，需要特殊处理
        if (typeof res === 'number') {
          !isNaN(res) && callback(res)
        } else {
          res && callback(res)
        }
      })
    },
    getRelValue (val, component, srcLocation, srcField, relField) {
      // 目标表的 id
      let tableId = srcLocation
      // 需要查询的字段
      let selectFieldId = srcField
      let map = {}
      // 条件集合
      map[relField] = val
      if (tableId && selectFieldId && relField && val) {
        return new Promise(async (resolve) => {
          let relationRequest = new AsyncRequest({
            type: 'relationRequest',
            requestType: 'get',
            path: `/form-api${this.$route.name === 'formRuntimeOutsideChain' ? '/publicPublish/runtime' : '/runtime'}/getRowByParameter`,
            data: {
              tableId: tableId,
              columnId: selectFieldId,
              parameter: map
            }
          })
          await relationRequest.sendRequest().then(res => {
            res.data ? resolve(res.data) : resolve(' ')
          })
        })
      } else {
        return new Promise(resolve => resolve())
      }
    }
  }
}
// 计算属性
const calculationMixin = {
  methods: {
    // 初始化
    initCal () {
      let expression = this.component.properties.calculate.calculationPanelData.expression
      // 不归档的控件临时将值赋给tempValue,展示用
      this.$emit('calculation', {'path': this.getCurrentPath(),
        'expression': expression,
        'isArchiveEnable': this.component.archive.enable,
        'isRealTime': this.component.properties.calculate && this.component.properties.calculate.realTime,
        'callback': (data) => {
          this.tempValue = data
        }})

      if (this.component.componentType === 'rc-time-interval') {
        this.$emit('calculation', {'path': this.getendTimeCurrentPath(),
          'expression': this.component.properties.calculate.calculationPanelData.secondExpression,
          'isArchiveEnable': this.component.archive.enable,
          'isRealTime': this.component.properties.calculate && this.component.properties.calculate.realTime,
          'callback': (data) => {
            this.tempValue = data
          }})
      }
    },
    calculation (expression) {
      if (expression.isArchiveEnable) {
        expression.callback = (data) => this.setValue(_.clone(expression.path), data)
      }
      this.getCalculationValue(expression)
    },
    /**
     * 获取计算结果
     */
    getCalculationValue (expression) {
      let watchObj = this.getWatchObj(expression)
      // 首先执行一遍  (表单 && (新建 || 编辑且开启了实时计算) )|| 下拉框|| 数据源...
      if ((this.initState.type === 'form' && this.value && (this.value.dataState === 'create' || (this.value[0] && this.value[0].dataState === 'create') || (this.formArgs && this.formArgs.formType === '编辑' && expression.isRealTime))) ||
        (this.component.componentType === 'rc-combobox' && this.component.properties.dataSource.enable && this.component.properties.dataSource.filter && Object.keys(this.component.properties.dataSource.filter).length) ||
        (this.component.componentType === 'rc-data-source' && this.component.properties.dataSourceData.filter && Object.keys(this.component.properties.dataSourceData.filter).length) ||
        (this.component.componentType === 'rc-table' && this.component.properties.tableDataSource.filter && Object.keys(this.component.properties.tableDataSource.filter).length)) {
        this.getCalValue(expression.expression, watchObj.watchPath, watchObj.watchArray)
          .then((data) => {
            expression.callback(data)
          })
      } else if (this.initState.type === 'process') {
        // 不是查看历史节点 && ( 非返回操作流转过的节点存在于历史节点中(即指向该节点的所有流转都走过了) || 开启了实时计算) || 下拉框...
        if ((!this.initState.historyNodeIds.includes(this.initState.currentNodeId) &&
          (!this.initState.connections.filter(it => it.targetNodeId === this.initState.currentNodeId && it.operationType === 'back').map(it => it.sourceNodeId).some(it => this.initState.historyNodeIds.includes(it)) || expression.isRealTime)) ||
          (this.component.componentType === 'rc-combobox' && this.component.properties.dataSource.enable && this.component.properties.dataSource.filter && Object.keys(this.component.properties.dataSource.filter).length) ||
          (this.component.componentType === 'rc-data-source' && this.component.properties.dataSourceData.filter && Object.keys(this.component.properties.dataSourceData.filter).length)) {
          this.getCalValue(expression.expression, watchObj.watchPath, watchObj.watchArray)
            .then((data) => {
              expression.callback(data)
            })
        }
      }
      // if (!this.findComponentValue(expression.path)) {
      //   this.getCalValue(expression.expression, watchObj.watchPath, watchObj.watchArray)
      //     .then((data) => {
      //       callback(data)
      //     })
      // }
      if (watchObj.watchPath.length > 0) {
        this.$watch(() => {
          let watch = []
          watchObj.watchPath.forEach(m => {
            watch.push(m.watchObj[m.columnId])
          })
          return watch
        }, _.debounce((newValue, oldValue) => {
          this.getCalValue(expression.expression, watchObj.watchPath, watchObj.watchArray)
            .then((data) => {
              expression.callback(data)
            })
        }, 50))
      }
      if (watchObj.watchArray.length > 0) {
        this.$watch(() => {
          let watch = []
          watchObj.watchArray.forEach(m => {
            watch.push(m.watchObj[m.relationId])
          })
          return watch
        }, _.debounce((newValue, oldValue) => {
          this.getCalValue(expression.expression, watchObj.watchPath, watchObj.watchArray)
            .then((data) => {
              expression.callback(data)
            })
        }, 50), {deep: true})
      }
    },
    getWatchObj (expression, isTable = null) {
      let data = this.dataService.data
      let paths = _.clone(expression.path)
      paths.pop()
      paths = _.tail(paths)
      let resultMap = this.getColumnIds(expression.expression)
      let watchPath = []
      let watchArray = []

      for (let i = 0; i < resultMap.length; i++) {
        let currentColumn = resultMap[i]
        let resultPath = this.getPath(data, _.clone(paths), currentColumn)
        let watchObj = this.dataService.data
        resultPath.forEach(m => {
          watchObj = watchObj[m]
        })
        if (watchObj instanceof Array) {
          watchObj = this.dataService.data
          // 如果监听的对象是一个数组的话
          let relationId = resultPath.pop()
          resultPath.forEach(m => {
            watchObj = watchObj[m]
          })
          watchArray.push({watchObj, relationId, 'columnId': currentColumn.columnId})
        } else {
          watchPath.push({watchObj, 'columnId': currentColumn.columnId})
        }
      }
      return {watchPath, watchArray}
    },
    getPath (data, paths, column) {
      let resultPath = []
      if (column.relationId) {
        let index = _.findIndex(paths, (m) => {
          return m === column.relationId
        })
        if (index < 0) {
          paths.push(column.relationId)
          resultPath = paths
        } else {
          resultPath = paths.splice(0, index + 1)
          if (paths[0].toString().length < 3) {
            resultPath.push(paths[0])
          }
        }
      }
      return resultPath
    },
    // 实现计算
    getCalValue (expression, watchObj, watchArray, arr = null) {
      if (expression) {
        let dataMap = {}
        watchObj.forEach(m => {
          if (arr) {
            if (arr[m.columnId] !== '' && typeof (arr[m.columnId]) !== 'undefined' && arr[m.columnId] !== null) {
              dataMap[m.columnId] = arr[m.columnId]
            }
          } else {
            let column = m.watchObj[m.columnId]
            if (column !== '' && typeof (column) !== 'undefined' && column !== null) {
              dataMap[m.columnId] = column
            }
          }
        })
        watchArray.forEach(m => {
          let prame = []
          m.watchObj[m.relationId].forEach(n => {
            if (n[m.columnId] !== '' && typeof (m.columnId) !== 'undefined' && n[m.columnId] !== null) {
              prame.push(n[m.columnId])
            }
          })
          if (prame.length > 0) {
            dataMap[m.columnId] = prame
          }
        })
        return new Promise(async (resolve) => {
          // 根据路由地址判断是否外链表单
          let calcRequest = new AsyncRequest({
            type: 'calcRequest',
            requestType: 'post',
            path: `/form-api/${this.$route.name === 'formRuntimeOutsideChain' ? 'publicPublish/' : ''}runtime/calc`,
            data: {'formula': expression, 'variables': dataMap}})
          let res = await calcRequest.sendRequest()
          resolve(res.data)
          // this.$axios.post(`/form-api/${this.$route.name === 'formRuntimeOutsideChain' ? 'publicPublish/' : ''}runtime/calc`, {'formula': expression, 'variables': dataMap}, {
          //   transformResponse: [function (data) {
          //     // 处理数字长度过长导致精度丢失问题
          //     return typeof data === 'number' ? data.request.response : data
          //   }]})
          //   .then(res => {
          //     resolve(res.data)
          //   })
        })
      }
      return new Promise((resolve) => {
        resolve('')
      })
    },
    // 赋值
    setValue (paths, data) {
      let columnId = paths.pop()
      paths = paths.filter(m => !this.getCurrentPath().includes(m))
      let dataObj = this.value
      paths.forEach(m => {
        dataObj = dataObj[m]
      })
      dataObj[columnId] = data
    },
    // 从公式获取 id 组
    getColumnIds (expression) {
      let result = []
      let reg = /\$\{(.+?)\}/g
      if (typeof expression !== 'number') {
        expression.match(reg) && expression.match(reg).map(m => {
          let columnId = m.replace(/[${}]/g, '').split(',')[0].split('+')[0]
          let relationId = m.replace(/[${}]/g, '').split(',')[0].split('+')[1]
          let type = m.replace(/[${}]/g, '').split(',')[2]
          if (type !== 'sql') {
            if (relationId === 'undefined') {
              relationId = undefined
            }
            if (!result.find(m => m.columnId === columnId && m.relationId === relationId)) {
              result.push({columnId, relationId})
            }
          }
        })
      }
      return result
    },
    // 获取当前控件下,指定路径的值
    findComponentValue (paths) {
      let path = _.clone(paths)
      let columnId = path.pop()
      path = path.filter(m => !this.getCurrentPath().includes(m))
      let dataObj = this.value
      if (path.length === 0) {
        return false
      } else {
        path.forEach(m => {
          dataObj = dataObj[m]
        })
        return dataObj[columnId]
      }
    }
  }
}

// 默认值方法
const defaultValueMixin = {
  methods: {
    callbackDefault (component, object) {
      let callback = object.callback || ((data) => this.updateChildValue(component.archive.columnId, data, object.index))
      this.initDefaultValue(component, callback, object.index, component.properties.default.defaultValue)
      if (component.componentType === 'rc-time-interval') {
        let callback = object.callback || ((data) => this.updateChildValue(component.properties.archived.endColumnId, data, object.index))
        this.initDefaultValue(component, callback, object.index, component.properties.default.secondDefaultValue)
      }
    },
    initDefaultValue (component, callback, index, defaultValue) {
      // 计算暂时用不到
      // let calculatine = this.component.properties.default.calculatine
      if (defaultValue) {
        let expression = defaultValue
        let valueArr = this.getColumnIds(expression)
        let obj = {}
        valueArr.forEach(m => {
          obj[m.columnId] = this.dataService.data[m.columnId]
        })
        this.$axios.post(`/form-api/${this.$route.name === 'formRuntimeOutsideChain' ? 'publicPublish/' : ''}runtime/calc`, {'formula': expression, 'variables': obj}, {
          transformResponse: [function (data) {
            // 处理数字长度过长导致精度丢失问题
            return typeof data === 'number' ? data.request.response : data
          }]})
          .then(res => {
            if (res.data || res.data === 0) {
              let defaultValue = res.data
              // 日期时间类型的话没有时间默认是0点
              if (component.archive.dataType === 'dateTime' && !moment(res.data, 'YYYY-MM-DD HH:mm:ss', true).isValid()) {
                defaultValue = `${res.data} 00:00:00`
              }
              callback(defaultValue)
            }
          })
      }
    }
  }
}
// 设置选项
const dataSource = {
  inject: ['eventBus'],
  methods: {
    loadTemplateOptions () {
      this.options = []
      this.component.properties.template.stringOptions.trim().split('\n').forEach(m => {
        this.options.push({id: m, value: m})
        this.isRequest = false
      })
      // 查看模式下添加
      if (this.value && this.disabled) {
        // 如果是多选，遍历增加
        if (this.component.componentType === 'rc-checkbox') {
          let values = this.value.split(',')
          values.forEach(value => !this.options.find(c => c.id === value) && this.options.push({id: value, value}))
        } else if (this.component.properties.multiple) {
          let values = this.value.split(', ')
          values.forEach(value => !this.options.find(c => c.id === value) && this.options.push({id: value, value}))
        } else {
          // 如果找不到这个选项，则加上
          if (!this.options.find(c => c.id === this.value)) {
            this.options.push({id: this.value, value: this.value})
          }
        }
      }
      this.eventBus.$emit('combobox.loadTemplate', { el: this })
    },
    loadDataSourceOptions (callback = '') {
      let filters = _.cloneDeep(this.component.properties.dataSource.filter)
      if (filters && Object.keys(filters).length) {
        Object.keys(filters).forEach(m => {
          if (filters[m].match(/\$\{(.*?)\}/)) {
            // 拿到所有归档id,并对其添加监听
            let expression = {
              'expression': _.clone(filters[m]),
              'path': this.getCurrentPath(),
              'callback': (data) => {
                filters[m] = data
                return this.search(filters).then(() => {
                  callback && callback()
                })
              }
            }
            this.needRequest = true
            this.getCalculationValue(expression)
          } else {
            // 未匹配到归档id的单独走计算
            this.calcParamsOptions(_.clone(filters[m])).then(res => {
              filters[m] = res.data
              return this.search(filters).then(() => {
                callback && callback()
              })
            })
          }
        })
        return Promise.resolve()
      } else {
        return this.search(filters).then(() => {
          callback && callback()
        })
      }
    },
    search (filters) {
      // 下拉框引用辅助表的最大记录数
      return this.$axios.get(`/report-api/report/definition/${this.component.properties.dataSource.reportId}?type=run`).then((res) => {
        let params = {'index': 1, 'size': 1000}
        if (res.data.maxTotal) {
          params.size = Number(res.data.maxTotal)
        }
        let columnId = this.component.properties.dataSource.columnId
        let showColumnId = this.component.properties.dataSource.showColumnId
        params.filters = filters
        let flag = true
        params.filters && Object.keys(params.filters).forEach(m => {
          if (params.filters[m].match(/\$\{(.*?)\}/)) {
            flag = false
          }
        })
        if (flag) {
          // 单选,复选,下拉框的关联数据源
          // fixme: 都是根据路由名来判断是外链的请求还是平台的请求， 不够严谨
          let getDataAPI = this.$route.name === 'formRuntimeOutsideChain' ? '/report-api/report/data/forPublic' : '/report-api/report/data'
          return this.$axios.get(`${getDataAPI}/${this.component.properties.dataSource.reportId}`, {params: params}).then((res) => {
            this.options = []
            res.data.forEach(m => {
              // 处理数字, 转为字符串类型
              m.id = typeof m[columnId] === 'number' ? String(m[columnId]) : m[columnId]
              m.value = m[showColumnId]
            })
            this.options = res.data
            this.isRequest = false
          }).catch(() => {
            this.isRequest = false
            this.options = []
          })
        } else {
          // 变化会触发下拉框的getShowValue计算导致清空当前显示值
          this.options = []
        }
      })
    },
    /**
     * 单独参数走计算
     * @params {String} 参数
     * @return {Promise} 返回一个执行结果
     */
    calcParamsOptions (params) {
      return this.$axios.post('/form-api/runtime/calc', {'formula': params}, {
        transformResponse: [function (data) {
          // 处理数字长度过长导致精度丢失问题
          return typeof data === 'number' ? data.request.response : data
        }]
      })
    }
  }
}

const interactionMixin = {
  mixins: [findVueMixin],
  provide () {
    return {
      rcGroupChildren: this.rcGroupChildren
    }
  },
  data () {
    return {
      rcGroupChildren: {
        hiddenComponent: []
      }
    }
  },
  methods: {
    async initInteraction () {
      let _this = this
      let interactions = []
      let columnComponent = []
      let tableComponent = []
      let data = this.dataService.data

      /** 根据控件ID找到控件的component和父级的component（如果有） */
      function findColumn (id) {
        let column = null
        let table = null
        // 先判断是不是columnComponent
        column = columnComponent.find(n => n.id === id)
        // 判断是不是TableComponent
        if (!column) {
          column = tableComponent.find(n => n.id === id)
        }
        // 最后TableComponent的控件
        if (!column) {
          for (let i = 0; i < tableComponent.length; i++) {
            column = tableComponent[i].children.find(n => n.id === id)
            if (column) {
              table = tableComponent[i]
              break
            }
          }
        }
        return {column, table}
      }

      /**
       * interaction:交互属性
       * value:控件的值
       * line:表格某行数据（可选）
       * */
      /* eslint-disable */
      function switchTrigger (interaction, value, isFirst, line) {
        interaction.triggerComponents.forEach((m, index) => {
          let triggerComponent = null
          if (m.triggerComponent.includes('ID')) {
            triggerComponent = findColumn(m.triggerComponent.slice(0, m.triggerComponent.length - 2))
          } else {
            triggerComponent = findColumn(m.triggerComponent)
          }
          let compareVal = m.compareVal
          if (triggerComponent.column.componentType === 'rc-numeric') {
            compareVal = compareVal * 1
          }
          getCompareResult(m, value[index], compareVal)
        })
        let condition = ''
        let relation = interaction.relation ? '&&' : '||'
        interaction.triggerComponents.forEach((m) => {
          condition += relation + m.result
        })
        condition = condition.slice(2)
        perform(interaction, eval(condition), isFirst, line)
      }

      /**
       * 执行
       * interaction：控件交互属性
       * Boolean：运算符判断结果
       * arr： 表格某行数据
       * */
      function perform (interaction, Boolean, isFirst, arr) {
        if (Boolean) {
          interaction.conforms.forEach(n => {
            doInteraction(n, isFirst, arr)
          })
        } else {
          interaction.noConforms.forEach(n => {
            doInteraction(n, isFirst, arr)
          })
        }
      }

      // 控件交互执行
      function doInteraction (item, isFirst, arr) {
        item.changeComponent && item.changeComponent.split(',').forEach(m => {
          let changeComponent = findColumn(m)
          if (changeComponent && changeComponent.column) {
            // 如果是流程需要判断执行控件在是否在当前节点
            if (_this._provided.initState.type === 'process') {
              if (['readonly', 'edit', 'required', 'noRequired', 'calculate', 'clear'].some(n => n === item.actionType)) {
                // 不存在当前节点说明是查看流程，只执行显示，隐藏功能
                if (_this._provided.initState.currentNodeId) {
                  // 执行控件为历史节点中的控件不执行节点交互
                  let historyNodeIds = _this._provided.initState.historyNodeIds
                  for (let id in historyNodeIds) {
                    // 找到每个历史节点对应的表单的id
                    let node = _this.processDefinition.process.nodes.find(o => o.id === historyNodeIds[id])
                    let nodeComponent = _this.processComponent.children.find(n => n.id === node.formId)
                    //  判断当前执行控件是否在历史节点 每个表单的全部归档的控件中
                    // 表格控件需要单独处理
                    let rcTables = nodeComponent.archivedChildren.filter(e => e.componentType === 'rc-table')
                    let needChangeComponent
                    if (rcTables) {
                      needChangeComponent = nodeComponent.archivedChildren.filter(e => e.componentType !== 'rc-table').find(el => el.id === m)
                      if (!needChangeComponent) {
                        // 表格自身也需要走操作校验。。
                        needChangeComponent = rcTables.find(el => el.id === m)
                        if (!needChangeComponent) {
                          for (let i = 0; i < rcTables.length; i++) {
                            needChangeComponent = rcTables[i].children.find(el => el.id === m)
                            if (needChangeComponent) break
                          }
                        }
                      }
                    } else {
                      needChangeComponent = nodeComponent.archivedChildren.find(el => el.id === m)
                    }
                    if (needChangeComponent) {
                      return false
                    }
                  }
                  // 执行控件不是本节点的不执行，因为可能是后面节点的控件
                  let currentNode = _this.processDefinition.process.nodes.find(o => o.id === _this._provided.initState.currentNodeId)
                  let currentNodeComponent = _this.processComponent.children.find(n => n.id === currentNode.formId)
                  // 表格控件需要单独处理
                  let rcTables = currentNodeComponent.archivedChildren.filter(e => e.componentType === 'rc-table')
                  let needChangeComponent
                  if (rcTables) {
                    needChangeComponent = currentNodeComponent.allChildren.filter(e => e.componentType !== 'rc-table').find(el => el.id === m)
                    if (!needChangeComponent) {
                      // 表格自身也需要走操作校验。。
                      needChangeComponent = rcTables.find(el => el.id === m)
                      if (!needChangeComponent) {
                        for (let i = 0; i < rcTables.length; i++) {
                          needChangeComponent = rcTables[i].children.find(el => el.id === m)
                          if (needChangeComponent) break
                        }
                      }
                    }
                  } else {
                    needChangeComponent = currentNodeComponent.allChildren.find(el => el.id === m)
                  }
                  if (!needChangeComponent) {
                    return false
                  }
                } else {
                  return false
                }
              }
            }
            // 表单编辑处理控件交互
            if (_this._provided.initState.type === 'form' && _this.dataService.data.dataState === 'update' && isFirst) {
              // 如果是报表编辑表单，第一次不执行控件交互(除显示隐藏操作)，后面监听数据改变执行
              if (['calculate', 'clear'].some(n => n === item.actionType)) {
                return false
              }
            }
            let vue = _this.findVueByComponentId(changeComponent.column.id)
            let componentType = changeComponent.column.componentType
            let tableVue
            let componentProperties
            if (arr) {
              tableVue = _this.findVueByComponentId(changeComponent.table.id)
              if (tableVue) {
                // 先去表格的columnsProperties找，找不到则用原来的。
                let list = tableVue.columnsProperties[arr.id]
                let findProp
                if (list && list.length) {
                  findProp = list.find(c => c.id === changeComponent.column.id)
                }
                componentProperties = findProp ? findProp.properties : _this.$_.cloneDeep(changeComponent.column.properties)
              }
            }
            let properties = {
              id: changeComponent.column.id,
              properties: componentProperties
            }

            function setList(tableVue, properties) {
              let list = _this.$_.cloneDeep(tableVue.columnsProperties[arr.id])
              if (list) {
                let i = list.findIndex(l => l.id === properties.id)
                i !== -1 && list.splice(i, 1)
                list.push(properties)
              } else {
                list = [properties]
              }
              tableVue.$set(tableVue.columnsProperties, arr.id, list)
              let x = tableVue.requiredList.findIndex(r => r.index === arr.index && r.id === properties.id)
              x !== -1 && tableVue.requiredList.splice(x, 1)
              tableVue.$nextTick(() => tableVue.requiredList.push({
                index: arr.index,
                id: properties.id,
                required: properties.properties.required,
                uuid: new Date().valueOf()
              }))
            }

            switch (item.actionType) {
              case 'show':
                if (arr && tableVue) {
                  properties.properties.hidden = false
                  properties.properties.seat = true
                } else {
                  changeComponent.column.properties.hidden = false
                  changeComponent.column.properties.seat = true
                  changeAll(changeComponent, false, false)
                }
                break
              case 'visibility':
                if (arr && tableVue) {
                  properties.properties.hidden = true
                  properties.properties.seat = true
                } else {
                  changeComponent.column.properties.hidden = true
                  changeComponent.column.properties.seat = true
                }
                break
              case 'hidden':
                if (arr && tableVue) {
                  properties.properties.hidden = true
                  properties.properties.seat = false
                } else {
                  changeComponent.column.properties.hidden = true
                  changeComponent.column.properties.seat = false
                }
                break
              case 'readonly':
                if (arr && tableVue) {
                  properties.properties.readonly = true
                } else {
                  if (!['rc-rich-box', 'rc-uuid'].includes(componentType)) {
                    changeComponent.column.properties.readonly = true
                  }
                }
                break
              case 'edit':
                if (arr && tableVue) {
                  properties.properties.readonly = false
                } else {
                  if (!['rc-rich-box', 'rc-uuid'].includes(componentType)) {
                    changeComponent.column.properties.readonly = false
                  }
                }
                break
              case 'required':
                if (!['rc-rich-box', 'rc-uuid', 'rc-cal-time', 'rc-login-user', 'rc-password'].includes(componentType)) {
                  if (arr && tableVue) {
                    properties.properties.required = true
                  } else {
                    changeComponent.column.properties.required = true
                  }
                }
                break
              case 'noRequired':
                if (!['rc-rich-box', 'rc-uuid', 'rc-cal-time', 'rc-login-user', 'rc-password'].includes(componentType)) {
                  if (arr && tableVue) {
                    properties.properties.required = false
                  } else {
                    changeComponent.column.properties.required = false
                  }
                }
                break
              case 'calculate':
                if (vue) {
                  if (!['rc-rich-box', 'rc-phone', 'rc-uuid', 'rc-cal-time', 'rc-login-user', 'rc-password'].includes(componentType)) {
                    let expression = {'path': vue.getCurrentPath(), 'expression': item.calculate}
                    let watchObj = _this.getWatchObj(expression, changeComponent.table)
                    if (arr) {
                      _this.getCalValue(expression.expression, watchObj.watchPath, watchObj.watchArray, arr).then((value) => {
                        try {
                          if (Object.prototype.toString.call(eval(value)) === '[object Array]') {
                            arr[changeComponent.column.archive.columnId] = JSON.parse(value)[arr.index]
                          } else {
                            arr[changeComponent.column.archive.columnId] = value
                          }
                        } catch (e) {
                          arr[changeComponent.column.archive.columnId] = value
                        }
                      })
                    } else if (changeComponent.table) {
                      if (data.hasOwnProperty(changeComponent.table.archive.relationId)) {
                        _this.getCalValue(expression.expression, watchObj.watchPath, watchObj.watchArray, arr).then((value) => {
                          // 如果是数组的话
                          try {
                            if (Object.prototype.toString.call(eval(value)) === '[object Array]') {
                              data[changeComponent.table.archive.relationId].forEach((n, i) => {
                                n[changeComponent.column.archive.columnId] = JSON.parse(value)[i]
                              })
                            } else {
                              data[changeComponent.table.archive.relationId].forEach(n => {
                                n[changeComponent.column.archive.columnId] = value
                              })
                            }
                          } catch (e) {
                            data[changeComponent.table.archive.relationId].forEach(n => {
                              n[changeComponent.column.archive.columnId] = value
                            })
                          }
                        })
                      }
                    } else {
                      if (data.hasOwnProperty(changeComponent.column.archive.columnId)) {
                        _this.getCalValue(expression.expression, watchObj.watchPath, watchObj.watchArray).then((value) => {
                          data[changeComponent.column.archive.columnId] = value
                        })
                      }
                    }
                  }
                }
                break
              case 'clear':
                if (!['rc-cal-time', 'rc-uuid', 'rc-login-user', 'rc-password'].includes(componentType)) {
                  if (arr) {
                    arr[changeComponent.column.archive.columnId] = ''
                  } else if (changeComponent.table) {
                    if (data.hasOwnProperty(changeComponent.table.archive.relationId)) {
                      data[changeComponent.table.archive.relationId].forEach(n => {
                        n[changeComponent.column.archive.columnId] = ''
                      })
                    }
                  } else {
                    if (data.hasOwnProperty(changeComponent.column.archive.columnId)) {
                      data[changeComponent.column.archive.columnId] = ''
                      if (componentType === 'rc-rich-box') {
                        _this.findVueBycolumnId(changeComponent.column.archive.columnId).editor.txt.html('')
                      }
                    }
                  }
                }
                break
            }
            // 执行完控件的properties修改之后，再覆盖原有的properties
            arr && tableVue && setList(tableVue, properties)
          }
        })
      }

      // 判断执行结果
      function getCompareResult (triggerComponent, value, compareVal) {
        switch (triggerComponent.triggerType) {
          case '=':
            triggerComponent.result = value == compareVal
            break
          case '!=':
            triggerComponent.result = value != compareVal
            break
          case '>':
            triggerComponent.result = value > compareVal
            break
          case '<':
            triggerComponent.result = value < compareVal
            break
          case 'includes':
            if (value === ' ' || value === '' || value === null || value === undefined) {
              triggerComponent.result = false
            } else {
              triggerComponent.result = value.includes(compareVal)
            }
            break
          case '空':
            let handleValue = false
            if (value === ' ' || value === '' || value === null || value === undefined) {
              handleValue = true
            }
            triggerComponent.result = handleValue
            break
          case '非空':
            let handleValue1 = false
            if (value !== ' ' && value !== '' && value !== null && value !== undefined) {
              handleValue1 = true
            }
            triggerComponent.result = handleValue1
            break
        }
      }

      // 设置结果
      async function setResult (triggerComponent) {
        return new Promise(async resolve => {
          await new AsyncRequest({
            type: 'calcRequest',
            requestType: 'post',
            path: `/form-api/${_this.$route.name === 'formRuntimeOutsideChain' ? 'publicPublish/' : ''}runtime/calc`,
            data: {'formula': triggerComponent.triggerComponent, 'variables': {}}
          }).sendRequest().then(res => {
            getCompareResult(triggerComponent, res.data, triggerComponent.compareVal)
            resolve()
          })
        })
      }

      // 如果是执行的控件交互为系统函数，执行一次即可，不管是编辑还是流程历史节点
      async function performSystemInteraction (interactions) {
        for (const item of interactions) {
          const relation = item.relation ? '&&' : '||'
          Promise.all(item.triggerComponents.map(m => setResult(m)))
            .then(() => perform(item, eval(item.triggerComponents.map(m => m.result).join(relation)), true))
        }
      }

      // 初始化数据
      async function initData (component, children) {
        let componentHyperlink = []
        let componentReport = []
        component.allChildren.forEach(o => {
          if (o.componentType === 'rc-hyperlink') {
            o.children = []
            componentHyperlink.push(o)
          }
          if (o.componentType === 'rc-report') {
            o.children = []
            componentReport.push(o)
          }
        })
        columnComponent = component.archivedChildren.filter(n => n instanceof ColumnComponent).concat(componentHyperlink).concat(componentReport)
        tableComponent = component.archivedChildren.filter(n => n instanceof TableComponent)
        // 分组控件特殊处理
        children.forEach(m => m.componentType === 'rc-group' && tableComponent.push(m))
        // 控件交互执行的是系统函数的，需要单独处理
        const interactionsAll = component.properties.componentInteraction || []
        // 非系统函数
        interactions = interactionsAll.filter(f => f.triggerComponents && f.triggerComponents.some(s => s.componentType !== 'SYSTEM'))
        // 系统函数单独执行
        await performSystemInteraction(interactionsAll.filter(f => f.triggerComponents && f.triggerComponents.some(s => s && s.componentType === 'SYSTEM')))
        // 处理历史数据
        interactions.forEach(m=>{
          if (!m.triggerComponents) {
            m.relation = true
            m.triggerComponents = [{triggerComponent: m.triggerComponent, triggerType: m.triggerType, compareVal: m.compareVal}]
            delete m.triggerComponent
            delete m.triggerType
            delete m.compareVal
          }
        })
      }

      if (this.processComponent) {
        let processComponentChildren = this.processComponent.children.map(m => m.children)
        processComponentChildren = [].concat.apply([], processComponentChildren)
        await initData(this.processComponent, processComponentChildren)
      } else {
        await initData(this.definition.form, this.definition.form.children)
      }

      interactions.forEach(interaction => {
        let values = []
        // 存暂时的交互控件
        let interactionTemp = {
          triggerComponents: [],
          conforms: interaction.conforms,
          noConforms: interaction.noConforms,
          relation: interaction.relation
        }

        interaction.triggerComponents.forEach(m => {
          // 归档的值
          let archivedValue = ''
          let triggerComponent = null
          // 下拉框id存的id是${控件id}ID
          if (m.triggerComponent.includes('ID')) {
            triggerComponent = findColumn(m.triggerComponent.slice(0, m.triggerComponent.length - 2))
            archivedValue = triggerComponent.column.archive.columnId
          } else {
            triggerComponent = findColumn(m.triggerComponent)
            archivedValue = triggerComponent.column.componentType === 'rc-combobox' && triggerComponent.column.properties.dataSource.enable ? triggerComponent.column.properties.archived.showColumnId : triggerComponent.column.archive.columnId
          }
          if (triggerComponent.column) {
            if (!triggerComponent.table) {
              // 非表格控件监听
              // 第一次加载控件的时候。数据的值存入到values，因为是push，所以交互的控件需要将同一个控件交互存入暂时的interactionTemp中
              // 因为switchTrigger 的方法接收符合条件的interaction的控件交互和符合条件的数据
              values.push(data[archivedValue])
              interactionTemp.triggerComponents.push({
                triggerComponent: m.triggerComponent,
                triggerType: m.triggerType,
                compareVal: m.compareVal
              })
              if (values) {
                switchTrigger(interactionTemp, values, true)
              }
              // 监听的时候把当前这个交互的选择控件都监听
              this.$watch(() => {
                let triggerComponents = interaction.triggerComponents.map(m => {
                  // 下拉框id存的id是${控件id}ID
                  let triggerComponent = null
                  let archivedValue = ''
                  if (m.triggerComponent.includes('ID')) {
                    triggerComponent = findColumn(m.triggerComponent.slice(0, m.triggerComponent.length - 2))
                    archivedValue = triggerComponent.column.archive.columnId
                  } else {
                    triggerComponent = findColumn(m.triggerComponent)
                    archivedValue = triggerComponent.column.componentType === 'rc-combobox' && triggerComponent.column.properties.dataSource.enable ? triggerComponent.column.properties.archived.showColumnId : triggerComponent.column.archive.columnId
                  }
                  if (!triggerComponent.table) {
                    // 非表格内的控件
                    return data[archivedValue]
                  } else {
                    // 表格内控件选择第一列，只是为了取当前交互选择控件的columnId
                    return data[triggerComponent.table.archive.relationId][0][archivedValue]
                  }
                })
                return triggerComponents
              }, _.debounce((val) => {
                // 这里通过上面的map方法将全部的数据的值进行监听，所以interaction取全部的，作为参数传入。下面表格的同理
                switchTrigger(interaction, val, false)
              }, 100))

            } else {
              interactionTemp.triggerComponents.push({
                triggerComponent: m.triggerComponent,
                triggerType: m.triggerType,
                compareVal: m.compareVal
              })
              data[triggerComponent.table.archive.relationId].forEach(n => {
                watchTableDoInteraction(n, [n[archivedValue]], interactionTemp)
              })
              this.$watch(() => {
                // 表格控件监听，一行行监听
                return data[triggerComponent.table.archive.relationId].length
              }, (newValue, oldValue) => {
                // 最后一行控件交互
                if (newValue > oldValue) {
                  let n = data[triggerComponent.table.archive.relationId][data[triggerComponent.table.archive.relationId].length - 1]
                  watchTableDoInteraction(n, [n[archivedValue]], interaction)
                }
              })

            }
          }
        })

      })

      function changeAll(changeComponent, hidden, seat) {
        // 如果容器控件隐藏，底下控件隐藏
        if (changeComponent.column.componentType === 'rc-group') {
          _this.rcGroupChildren.hiddenComponent = _.cloneDeep(changeComponent.column).recursionGetComponents()
          _this.rcGroupChildren.hiddenComponent.forEach(m => {
            let changeComponent = findColumn(m.id)
            if (changeComponent.column) {
              changeComponent.column.properties.hidden = hidden
              changeComponent.column.properties.seat = seat
            }
          })
        }
      }

      function watchTableDoInteraction(n, values, interaction) {
        if (values.length) {
          switchTrigger(interaction, values, true, n)
        }
        _this.$watch(() => {
          let tableTriggerComponents = interaction.triggerComponents.map(m => {
            let triggerComponent = null
            // 归档的值
            let archivedValue = ''
            if (m.triggerComponent.includes('ID')) {
              triggerComponent = findColumn(m.triggerComponent.slice(0, m.triggerComponent.length - 2))
              archivedValue = triggerComponent.column.archive.columnId
            } else {
              triggerComponent = findColumn(m.triggerComponent)
              archivedValue = triggerComponent.column.componentType === 'rc-combobox' && triggerComponent.column.properties.dataSource.enable ? triggerComponent.column.properties.archived.showColumnId : triggerComponent.column.archive.columnId
            }
            if (!triggerComponent.table) {
              return data[archivedValue]
            } else {
              return n[archivedValue]
            }
          })
          return tableTriggerComponents
        }, _.debounce((val) => {
          switchTrigger(interaction, val, false, n)
        }, 100), {deep: true})

      }
    }
  }
}

//  阿里云oss上传后的内容封装
const ossMixin={
  methods: {
    getUploadFormData(key,file){
      let formData = new FormData()
      // let data=this.getOssPolicyAndSignature()
      // 注意formData里append添加的键的大小写
      formData.append('key', key) // 存储在oss的文件路径
      formData.append('OSSAccessKeyId', sessionStorage.getItem('accessKeyId')) // accessKeyId
      formData.append('policy', sessionStorage.getItem('policy')) // policy
      formData.append('signature', sessionStorage.getItem('signature')) // 签名
      // 如果是base64文件，那么直接把base64字符串转成blob对象进行上传就可以了
      formData.append('file', file, file.name)
      formData.append('success_action_status', 200) // 成功后返回的操作码
      return formData
    },
    getResult (key,name) {
      return[
        {
          code: 1,
          status: 'success',
          result: {
            createtime: moment().format('YYYY-MM-DD hh:mm:ss'),
            dir: `/${key}`,
            file: name
          }
        }]
    },
    getSuffix (fileName) {
      let pos = fileName.lastIndexOf('.')
      let suffix = ''
      if (pos !== -1) {
        suffix = fileName.substring(pos)
      }
      return suffix
    },
    getOssKey(type,fileName){
      return `ak0000000386/${CookieOperation.getTenantId()}/${type}/${moment().format('YYYYMM')}/${UUID.create() + this.getSuffix(fileName)}`
    }
    // 前端编码阿里云oss签名
    // getOssPolicyAndSignature(){
    //   let policyText = {
    //     "expiration": moment.utc().add(1,'h').format(), //设置该Policy的失效时间，超过这个失效时间之后，就没有办法通过这个policy上传文件了
    //     "conditions": [
    //       ["content-length-range", 0, 1048576000] // 设置上传文件的大小限制
    //     ]
    //   }
    //   let str=JSON.stringify(policyText)
    //   let policy=Base64.encode(str)
    //   let bytes = Crypto.HMAC(Crypto.SHA1, policy, sessionStorage.getItem('accessKeySecret'), { asBytes: true })
    //   let signature = Crypto.util.bytesToBase64(bytes)
    //   return {policy:policy,signature:signature}
    // }
  }
}

const uploadMixin = {
  data(){
    return{
      dragActive: false,
      dragenterTarget: null
    }
  },
  methods:{
    dragableEvent (e) {
      e.preventDefault()
      e.stopPropagation()
      e.dataTransfer.dropEffect = 'copy'
      e.dataTransfer.effectAllowed = 'copy'
    },
    // 允许组件的拖动事件
    initDragEvent(ref){
      this.$refs[ref].addEventListener ?this.$refs[ref].addEventListener('drop', this.dragableEvent): this.$refs[ref].$el.addEventListener('drop', this.dragableEvent)
      this.$refs[ref].addEventListener ?this.$refs[ref].addEventListener('dragover', this.dragableEvent): this.$refs[ref].$el.addEventListener('dragover', this.dragableEvent)
    },
    destroyDragEvent(ref){
      this.$refs[ref].removeEventListener ?this.$refs[ref].removeEventListener('drop', this.dragableEvent): this.$refs[ref].$el.removeEventListener('drop', this.dragableEvent)
      this.$refs[ref].removeEventListener ?this.$refs[ref].removeEventListener('dragover', this.dragableEvent): this.$refs[ref].$el.removeEventListener('dragover', this.dragableEvent)
    },
    dragenterEvent(e){
      this.dragenterTarget = e.target
      this.dragActive = true
    },
    dragleaveEvent(e){
      if (this.dragenterTarget === e.target) {
        this.dragActive = false
        this.dragenterTarget = null
      }
    },
    checkFiles(fileList){
      let fileType = ''
      let allowType = ['png', 'jpg', 'jpeg', 'gif']
      // 检测图片
      fileList.forEach(f => {
        fileType = f.name.split('.').pop()
        if (this.component.properties.listType === 'picture') {
          // 图片选择控件
          if (!allowType.some(n => n === fileType.toLocaleLowerCase())) {
            f.illegalType = true
          }
        } else if (this.component.properties.allowFileType && this.component.properties.allowFileType.length !== 0) {
          // 文件选择控件和表格内的文件选择 如果设置了上传文件的允许类型,则判断
          if (!this.component.properties.allowFileType.some(n => n === fileType.toLowerCase())) {
            f.illegalType = true
          }
        }
        if (f.size >= this.maxSize) {
          f.illegalSize = true
        }
      })
    },
    // 拖动上传
    dragUploadFile (event) {
      if (event.dataTransfer.files.length > 0) {
        let illegalSizeArray = []
        let illegalTypeArray = []
        if (this.component.properties.multiple) {
          let fileList = Array.prototype.slice.call(event.dataTransfer.files)
          this.checkFiles(fileList)
          fileList.forEach(file => {
            if (!file.illegalSize && !file.illegalType){
              this.uploadFile({'file': file})
            } else if (file.illegalSize) {
              illegalSizeArray.push(file.name)
            } else if (file.illegalType) {
              illegalTypeArray.push(file.name)
            }
          })
          // 错误提示
          if (illegalSizeArray.length > 0) {
            this.$message({
              type: 'error',
              message: `${illegalSizeArray.join()}超过${this.component.properties.fileSize || 50}M限制`
            })
          } else if (illegalTypeArray.length > 0) {
            this.$message({
              type: 'warning',
              message: this.component.properties.listType === 'picture' ? '图片类型上传文件只能是图片格式':`只能上传${this.component.properties.allowFileType.join()}格式的文件`
            })
          }
        } else {
          // 没开多选时上传最后一个
          let file = event.dataTransfer.files[event.dataTransfer.files.length - 1]
          this.checkFiles([file])
          if (!file.illegalSize && !file.illegalType){
            this.uploadFile({'file': file})
          } else if (file.illegalSize) {
            this.$message.error(`${file.name} 超过${this.component.properties.fileSize || 50}M限制`)
          } else if (file.illegalType) {
            this.$message.warning(this.component.properties.listType === 'picture' ? '图片类型上传文件只能是图片格式':`只能上传${this.component.properties.allowFileType.join()}格式的文件`)
          }
        }
      }
      this.dragActive = false
    },
  }
}
export {
  componentMixin,
  containerInitMixin,
  containerMixin,
  inputMixin,
  relFunMixin,
  calculationMixin,
  defaultValueMixin,
  dataSource,
  interactionMixin,
  ossMixin,
  uploadMixin
}



// WEBPACK FOOTER //
// ./src/components/form/runtime/components/mixins.js